import { useFormikContext } from 'formik';

import { StepperControls } from './StepperControls';

interface Props {
  handleBack: () => void;
  nextText?: string;
  backText?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
}
// This is a utility component that allows you to enter a formik context
// The alternative would be to use the function as a child pattern in the parent component but that is a pre hooks pattern
export const StepperControlsFormik = ({
  handleBack,
  nextText,
  backText,
  isLoading = false,
  isDisabled = false,
}: Props) => {
  const { handleSubmit } = useFormikContext();

  return (
    <StepperControls
      handleBack={handleBack}
      handleNext={handleSubmit}
      backText={backText}
      nextText={nextText}
      isLoading={isLoading}
      isNextDisabled={isLoading || isDisabled}
    />
  );
};
